// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['eu_ES']  = {
  "name": "eu_ES",
  "day": {
    "abbrev": [
      "ig.",
      "al.",
      "ar.",
      "az.",
      "og.",
      "or.",
      "lr."
    ],
    "full": [
      "igandea",
      "astelehena",
      "asteartea",
      "asteazkena",
      "osteguna",
      "ostirala",
      "larunbata"
    ]
  },
  "month": {
    "abbrev": [
      "urt",
      "ots",
      "mar",
      "api",
      "mai",
      "eka",
      "uzt",
      "abu",
      "ira",
      "urr",
      "aza",
      "abe"
    ],
    "full": [
      "urtarrila",
      "otsaila",
      "martxoa",
      "apirila",
      "maiatza",
      "ekaina",
      "uztaila",
      "abuztua",
      "iraila",
      "urria",
      "azaroa",
      "abendua"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%a, %Y.eko %bren %da",
  "time24": "%T",
  "dateTime": "%y-%m-%d %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

